<template>
  <div class="container">
    <div class="left-board">
      <div class="components-item" v-for="(item, index) in typeList" :key="index">
        <span>{{ item.label }}</span>
        <img :src="item.img" alt="" />
        <a-button class="addItem" type="danger" @click="deleteItemList(index)"> 删除 </a-button>
      </div>
    </div>
    <div class="center-board">
      <div class="center-title">组件类型:</div>
      <div class="itemText" v-for="(item, index) in addList" :key="index">
        <span>{{ item.title }}：</span>
        <a-input v-if="item.type == 'input'" class="item" placeholder="请输入" />
        <a-date-picker v-if="item.type == 'date'" class="item" />
        <a-time-picker v-if="item.type == 'time'" class="item" />
        <a-upload v-if="item.type == 'upload'" action="/upload.do" list-type="picture" class="item">
          <a-button> <a-icon type="upload" /> 点击上传文件 </a-button>
        </a-upload>
        <a-button class="addItem" type="primary" @click="addItemList(index)">{{ item.content }} </a-button>
      </div>
      <div class="center-bottom">
        <!-- :rules="rulesFixation" -->
         <a-form-model
            :model="formData"
            ref="ruleFormFixation"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-row v-for="(item, index) in formData" :key="index">
              <a-col :span="24">
                <a-form-model-item :label="item.title" prop="orderCode">
                  <a-input v-if="item.type == 'input'" v-model="item.value" :placeholder="item.content" allowClear style="width:100%;"></a-input>
                  <a-date-picker v-model="item.value" valueFormat="YYYY-MM-DD" :placeholder="item.content" allowClear v-if="item.type == 'date'" style="width:100%;"/>
                  <a-upload :action="item.preUrl" :headers="headers" name="file" :defaultFileList="defaultFileList"
                    v-if="item.type == 'upload'" :remove="removeFile"  @preview="previewFile"
                    :data="{
                      type: 'asset',
                      fileName: item.fileName,
                      assetSn: item.assetSn,
                      deptId: item.deptId,
                    }"
                    method="post"
                    :beforeUpload="beforeUpload"
                    @change="handleChange"
                  >
                    <a-button> <a-icon type="upload" /> 上传文件 </a-button>
                  </a-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- <span>{{formData}}</span> -->
             <a-button @click="commit"> 提交 </a-button>
         </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
export default {
  data() {
    return {
      fileList: [],
      removeList: [],
      defaultFileList: [],
      headers: {},
      keyData: [
        'orderId',
      'orderName'],
      formData: [{
         orderId: '',
         value: undefined,
         title: '输入框',
         type: 'input',
         content: '请输入',
      },
      {
          orderName: '',
          value: undefined,
          title: '日期选择器',
          type: 'date',
          content: '请选择',
      },{
         preUrl: process.env.VUE_APP_API_BASE_URL + '/file/file/upload_asset',
         orderId: '',
         value: undefined,
         title: '输入框',
         type: 'upload',
         content: '请输入',
         fileName: '',
         assetSn: '',
         deptId: '',
      }],
       labelCol: {
        span: 3,
      },
      wrapperCol: {
        span: 21,
      },
      imgs: [],
      typeList: [],
      addList: [
        {
          title: '输入框',
          type: 'input',
          content: '添加输入框',
        },
        {
          title: '日期选择器',
          type: 'date',
          content: '添加日期选择框',
        },
        {
          title: '时间选择器',
          type: 'time',
          content: '添加时间选择框',
        },
        {
          title: '上传文件',
          type: 'upload',
          content: '添加上传文件组件',
        },
      ],
      //校验规则
        rulesFixation: {
        orderId: [
          {
            required: true,
            message: '申请单号不能为空',
            trigger: 'blur',
          },
        ],
        }
    }
  },
  mounted() {},
  watch: {
      fileList() {
        console.log(this.fileList, 'this.fileList=========================22222222222222222222222222')
      },
    },
  methods: {
    //上传文件
    handleChange(info) {
      this.fileList.forEach((item, idx) => {
        if (item.type != 'application/pdf') {
          info.fileList.splice(idx, 1)
        }
      })
      if (info.file.status !== 'uploading') {
        // info.fileList.splice(info.fileList.length - 1, 1)
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
        this.fileList.push(info.file.response.data + ',' + info.file.name)
        // info.fileList.push(info.file)
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    //预览文件
      previewFile(file) {
      console.log(file)
      window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
    },
    //删除文件
    removeFile(file) {
      this.removeList.push(file.response.data)
      let data = file.response.data + ',' + file.name
      this.formData.forEach((item, idx) => {
        if (item.value == data) {
          this.fileList.splice(idx, 1)
        }
      })
      console.log(this.fileList, this.defaultFileList)
    },
    // 上传限值
     beforeUpload(file) {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      // this.upload.asset_sn = this.detailsrow.asset_sn
      // this.upload.dept_id = this.detailsrow.dept_id
      var isType = true
      this.file_name = file.name
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传头文件大小不能超过 10MB!')
      }
      if (file.type != 'application/pdf') {
        isType = false
        this.$message.error('只能上传pdf文件')
      }
      return isLt2M && isType
    },
    commit() {
      this.formData.forEach(item => {
        console.log(item, 'item=====================')
        for(var i = 0; i< this.keyData.length; i++) {
           if((this.keyData[i] in item)) {
            item[this.keyData[i]] = item.value
          }

        }
      })
     console.log(this.formData, 'formData===================')
    },
    //date.png
    addItemList(index) {
      console.log(index, 'index===================')
      if (index == 0) {
        this.typeList.push({
          label: '输入框：',
          type: 'input',
          img: require('../../../assets/image/input.png'),
        })
      } else if (index == 1) {
        this.typeList.push({
          label: '日期选择：',
          type: 'date',
          img: require('../../../assets/image/date.png'),
        })
      } else if (index == 2) {
        this.typeList.push({
          label: '时间选择：',
          type: 'time',
          img: require('../../../assets/image/time.png'),
        })
      } else if (index == 3) {
        this.typeList.push({
          label: '上传文件：',
          type: 'upload',
          img: require('../../../assets/image/upload.png'),
        })
      }

    },
    deleteItemList(index) {
      this.typeList.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.center-board {
  float: left;
  width: 40%;
  height: 1000px;
  /* background-color: rgb(243, 174, 174); */
  padding: 20px;
}
.left-board {
  float: left;
  width: 60%;
  height: 1000px;
  background-color: rgb(183, 247, 185);
}
.components-title {
  font-size: 20px;
}
.components-item {
  display: flex;
  align-content: space-between;
  width: 48%;
  margin: 2% 5%;
  transition: transform 0ms !important;
}
/* .components-item .item {
    height: 45px;

   } */
.components-item img {
  height: 45px;
  width: 70%;
  padding: 1px;
  border-radius: 5px;
}
.components-item span {
  text-align: center;
  line-height: 45px;
  width: 20%;
}
.itemText {
  display: flex;
  align-content: space-between;
  margin-bottom: 10px;
  height: 45px;
}
.itemText span {
  text-align: center;
  line-height: 45px;
  width: 20%;
}
.itemText .item {
  height: 45px;
  width: 100%;
  margin: 0;
}
.addItem {
  height: 45px;
  margin-left: 10px;
}
.center-bottom {
  color: black;
  margin-top: 10px;
  padding: 10px;
}
</style>